// extracted by mini-css-extract-plugin
export default {"SectionsContainer":"About_SectionsContainer__eDBOy","Heading":"About_Heading__p9PyL","Subheading":"About_Subheading__du28Z","Link":"About_Link__lgSWO"};